import Vue from 'vue';
import VueRouter from 'vue-router';
import UserLanding from '../views/UserLanding.vue';
import RemotePaymentLink from '../views/RemotePaymentLink.vue';
import PayDone from '../views/PayDone.vue';
import NotFound from '../views/NotFound.vue';
import InternalError from '../views/InternalError.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: () => {
      // the function receives the target route as the argument
      // return redirect path/location here.
      window.location.href = process.env.VUE_APP_LANDING_PAGE;
    },
  },
  {
    path: '/i/ticket',
    name: 'pay-done',
    component: PayDone,
  },
  {
    path: '/:slug',
    name: 'user-landing',
    component: UserLanding,
  },
  {
    path: '/i/404',
    name: '404',
    component: NotFound,
  },
  {
    path: '/i/error',
    name: 'internal-error',
    component: InternalError,
  },
  {
    path: '/:slug/:uniquelink',
    name: 'payment-link',
    component: RemotePaymentLink,
    props: true,
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
